export default __webpack_public_path__ + "static/18-58dfd40c09186efe969bfb11b4e464a0.png";